var map = {
	"./background/stripe_background.jpg": "fec6",
	"./banner/casino.jpg": "19e5",
	"./banner/casual.jpg": "f097",
	"./banner/fishing.jpg": "488c",
	"./banner/man--mobile.jpg": "4db5",
	"./banner/man.jpg": "b3aa",
	"./banner/p2p.jpg": "e3b9",
	"./banner/slot.jpg": "f13f",
	"./casino_banner/Dream gaming.jpg": "cc7d",
	"./casino_banner/N2-Live.jpg": "119f",
	"./casino_banner/SA gaming.jpg": "a1e6",
	"./casino_banner/Sexy Gaming.jpg": "0fa9",
	"./casino_banner/WM casino.jpg": "df32",
	"./casual_banner/Ace Round.jpg": "2383",
	"./casual_banner/Atlantis.jpg": "2b2a",
	"./casual_banner/Courier Sweeper.jpg": "45b0",
	"./casual_banner/Crown _ Anchor.jpg": "5540",
	"./casual_banner/Dungeon.jpg": "5908",
	"./casual_banner/E.T. Races.jpg": "97cd",
	"./casual_banner/Fruit Burst.jpg": "d732",
	"./casual_banner/Heads _ Tails.jpg": "0e9d",
	"./casual_banner/Mafia Syndicate.jpg": "e501",
	"./casual_banner/Maze.jpg": "639a",
	"./casual_banner/Rise of Horus.jpg": "bd75",
	"./casual_banner/Roll the Dice.jpg": "fdf8",
	"./casual_banner/Surf zone.jpg": "28ee",
	"./casual_banner/Temple of dead.jpg": "2ac6",
	"./casual_banner/Treasure Mania.jpg": "9340",
	"./fishing_banner/Fisherman Gold.jpg": "ae8d",
	"./fishing_banner/Moster Awaken.jpg": "529d",
	"./fishing_banner/Tokyo Kombat.jpg": "b210",
	"./fishing_banner/fish haiba.jpg": "54fc",
	"./fishing_banner/fish hunter spongebob.jpg": "21f8",
	"./games/background.jpg": "7679",
	"./games/deadwood.jpg": "2e67f",
	"./games/ironbank.jpg": "0cb2",
	"./games/moneytrain2.jpg": "efb4",
	"./games/pokdeng.jpg": "2a89",
	"./games/thor.jpg": "db05",
	"./games/vikings.jpg": "5012",
	"./p2p_banner/Bingo.jpg": "5d4f",
	"./p2p_banner/Hilo.jpg": "dbed",
	"./p2p_banner/Kang.jpg": "32f9",
	"./p2p_banner/Namtaopupa.jpg": "b2ea",
	"./p2p_banner/Pokdeng.jpg": "a8aa",
	"./promotions/Pro-08.jpg": "40e2",
	"./promotions/Pro-09.jpg": "fa25",
	"./promotions/Pro-10.jpg": "bdb3",
	"./promotions/Pro-11.jpg": "0c63",
	"./promotions/Pro-12.jpg": "6130",
	"./promotions/Pro-13.jpg": "8afe",
	"./promotions/Pro-money truck-desktop.jpg": "3755",
	"./promotions/Pro-money truck-mobile.jpg": "57ca",
	"./slot_banner/caishen_wins.jpg": "9b3a",
	"./slot_banner/deadwood.jpg": "bc69",
	"./slot_banner/dragon_tiger.jpg": "7ccd",
	"./slot_banner/egypt_s_book_of_mystery.jpg": "349b",
	"./slot_banner/four_dragons.jpg": "bd07",
	"./slot_banner/genie_jackpots.jpg": "fb64",
	"./slot_banner/iron_bank.jpg": "eb10",
	"./slot_banner/money_train2.jpg": "537c",
	"./slot_banner/ramses_revenge.jpg": "63e9",
	"./slot_banner/roma.jpg": "6db0",
	"./slot_banner/sanquentin.jpg": "235a",
	"./slot_banner/sweet_bonanza.jpg": "dbd9",
	"./slot_banner/thor.jpg": "4d28",
	"./slot_banner/vikings.jpg": "411a",
	"./slot_banner/wild_west.jpg": "2166",
	"./studio_banner/blueprint.jpg": "25c4",
	"./studio_banner/dream_gaming.jpg": "095e",
	"./studio_banner/joker.jpg": "363b",
	"./studio_banner/pg.jpg": "0e2f",
	"./studio_banner/sa.jpg": "c0d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";